import { Heading } from "../Heading/Heading";
import * as React from "react";

export function AboveTheFold(): JSX.Element {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-pt-[111px] !tw-text-center max-lg:tw-pt-[24px] max-sm:!tw-h-auto max-sm:!tw-pb-0">
      <div className="tw-flex-col tw-items-center max-container:!tw-w-[83%] max-lg:!tw-pt-10 max-sm:!tw-w-[90%] max-sm:!tw-pt-8 min-container:!tw-w-[60%] min-lg:tw-flex ">
        <Heading headerType={1}>
          Create <span className="tw-font-PassengerSerif tw-italic">standout </span>visual
        </Heading>
        <Heading headerType={1}>comms and content</Heading>
        <div>
          <Heading
            headerType={2}
            className="tw-w-full tw-pt-[18px] !tw-text-center !tw-text-2xl !tw-font-normal !tw-text-grey_scale-200 max-sm:!tw-w-full max-sm:!tw-text-xl"
          >
            Shorthand makes it easy to publish beautifully engaging brand publications, features, reports, digital magazines, and
            internal comms — with up to 13&times; higher engagement.
          </Heading>
        </div>
      </div>
    </div>
  );
}
